import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'sale',
  templateUrl: './sale.component.html',
  styleUrls: ['./sale.component.scss']
})
export class SaleComponent implements OnInit {

  @Input() sale;
  active = false;

  constructor(public shared: Shared) { }

  ngOnInit() {
      //console.log(this.sale);
  }

  toggleActive(event){
      if(this.shared.isNullOrUndefined(event)){
          return;
      }
      if(event.target.className != 'global_sale_slider' && event.target.className != 'global_sale_checkbox_container' && event.target.localName === 'div' ){
          this.active = !this.active;
      }
  }

  toggleSaleActive(){
      if(!this.shared.noGlobalSale){
          this.shared.salesRef.update(this.shared.globalSale.$key, {active:false});
      }
      this.shared.salesRef.update(this.sale.$key, {active : !this.sale.active});
  }

  save(){
      const key = this.sale.$key;
      delete this.sale.$key;
      this.shared.salesRef.update(key, this.sale);
  }

  deleteSale(){
      this.shared.salesRef.remove(this.sale.$key);
      this.togglePopup();
  }

  togglePopup(){
      this.shared.popup = !this.shared.popup;
  }


  getTiers(){
      if(this.sale.tiers === "all"){
          return "all tiers";
      } else {
          return "tier "+this.sale.tiers;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/sale/sale.component.ts